import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {GenerateCodeService} from "@/service/GenerateCodeService.ts";
import {CheckStatusResponse} from "@/model/response/generateCode/CheckStatusResponse.ts";


export type GenerateCodeState = {
    loading: boolean;
    showDownload: boolean
    error: string
    applicationS3Url: string
    applicationS3Urls: {
        [applicationId: number]: string;
    }
    applicationDatabaseUrl: string
    applicationDatabaseUrls: {
        [applicationId: number]:
            string
    }
};

const initialState: GenerateCodeState = {
    loading: false,
    showDownload: false,
    error: "",
    applicationS3Url: "",
    applicationS3Urls: {},
    applicationDatabaseUrl: "",
    applicationDatabaseUrls: {}
};

const action = {
    generate: createAsyncThunk(
        "generateCode/generate",
        async (payload: number, thunkAPI) => {
            return (await GenerateCodeService.generate(thunkAPI, payload)).data;
        }
    ),
    generateKotlin: createAsyncThunk(
        "generateCode/generateKotlin",
        async (payload: number, thunkAPI) => {
            return (await GenerateCodeService.generateKotlin(thunkAPI, payload)).data;
        }
    ),
    checkStatus: createAsyncThunk(
        "generateCode/checkStatus",
        async (payload: number, thunkAPI) => {
            return (await GenerateCodeService.checkStatus(thunkAPI, payload)).data;
        }
    ),
};

const slice = createSlice({
    name: "generateCode",
    initialState,
    reducers: {
        setLoading(state, {payload}) {
            state.loading = payload;
        },
        setS3Url: (state, action) => {
            const {applicationId, url} = action.payload;
            state.applicationS3Urls[applicationId] = url;
        },
        setShowDownload: (state, {payload}) => {
            state.showDownload = payload;
        },
        reset: () => ({...initialState})
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.generate.pending, (state) => {
                state.loading = true;
            })
            .addCase(action.generate.fulfilled, (state) => {
                state.loading = false;
            }).addCase(action.generate.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'An error occurred';
        })
            .addCase(action.generateKotlin.pending, (state) => {
                state.loading = true;
            })
            .addCase(action.generateKotlin.fulfilled, (state) => {
                state.loading = false;
            }).addCase(action.generateKotlin.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'An error occurred';
        })
        
        .addCase(action.checkStatus.pending, (state) => {
            state.loading = false
        }).addCase(action.checkStatus.fulfilled, (state, action) => {
            state.loading = false
            const response = action.payload as CheckStatusResponse
            if (response.responseCode == "00") {
                state.applicationS3Url = response.applicationS3Url
                state.applicationDatabaseUrl = response.applicationDatabaseUrl
                state.applicationS3Urls = {[Number(response.applicationId)]: response.applicationS3Url}
                state.applicationDatabaseUrls = {[Number(response.applicationId)]: response.applicationDatabaseUrl}
            }
        });
    },
});

export const generateCode = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
};
